var _path, _path2, _use, _polygon, _use2, _use3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmsterdam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 V230 V175 a125 125 0 0 0 250 0 V0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M5,5 V175 a120 120 0 0 0 78.333 112.564 V5 Z",
    fill: "#db0000"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    x: -250,
    transform: "scale(-1, 1)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "X",
    points: "117.5,15 132.5,15 132.5,42.5 160,42.5 160,57.5 132.5,57.5 132.5,85 117.5,85 117.5,57.5 90,57.5 90,42.5 117.5,42.5",
    fill: "#fff",
    transform: "rotate(45 125 50)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    y: 100
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    y: 200
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmsterdam);
export default __webpack_public_path__ + "static/media/amsterdam.b56a8a5d02de968dafbb679ceb3be20e.svg";
export { ForwardRef as ReactComponent };